import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './Home.vue'
import Debates from './Debates.vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/styles.css'

Vue.use(VueRouter);
Vue.use(BootstrapVue);

Vue.config.productionTip = false

const routes = [
  { path: '/debates', component: Debates },
  { path: '/', component: Home }
];

const router = new VueRouter({
  routes // short for `routes: routes`
});

new Vue({
  el: '#app',
  router: router,
  render: h => h('router-view')
});
